import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { useTrackConfig } from './Tracker';
import TrackPageView from './TrackPageView';
const Context = createContext(null);
Context.displayName = 'TrackRouteContext';
const TrackRouteNestingGuard = ({ warnNested, children }) => {
    const possibleParent = useContext(Context);
    const { path } = useRouteMatch();
    if (warnNested && possibleParent !== null) {
        console.warn(`A TrackRoute (${path}) is nested inside another TrackRoute (${possibleParent})`);
    }
    return (_jsx(Context.Provider, Object.assign({ value: path }, { children: children }), void 0));
};
const TrackRoute = props => {
    const { reportPageViewOnLeafOnly, warnNestedTrackRoute, render, children, component, ...routeDefinition } = props;
    const contextConfig = useTrackConfig();
    const config = { ...contextConfig, ...props };
    return (_jsx(Route, Object.assign({}, routeDefinition, { children: _jsx(TrackRouteNestingGuard, Object.assign({ warnNested: config.warnNestedTrackRoute }, { children: _jsx(TrackPageView, Object.assign({ disabled: config.reportPageViewOnLeafOnly && !!props.children }, { children: _jsx(Route, Object.assign({ render: render, component: component }, routeDefinition, { children: children }), void 0) }), void 0) }), void 0) }), void 0));
};
export default TrackRoute;
